<template>
    <Header></Header>

    <Transition>
        <main class="opui-main opui-pt-6">
            <div class="opui-container" v-if="loaded && pack">
                <div class="optpl-details-container">
                    <a href="#" @click.prevent="$router.go(-1)" class="optpl-back"><i class="opui-fa opui-fa-arrow-left"></i> Go back</a>

                    <div class="optpl-details-card">
                        <div class="optpl-details-card__info">
                            <div class="optpl-details-card__collections"><span>Marketplace</span></div>
                            <h2>{{ pack.title }}</h2>
                            <div class="optpl-details-card__description" v-html="pack.description"></div>

                            <div class="optpl-details-card__tags-container">
                                <div class="optpl-details-card__tags" v-for="tagGroup in pack.tags">
                                    <h3>{{ tagGroup.title }}</h3>
                                    <span v-for="tag in tagGroup.tags">{{ tag.title }}</span>
                                </div>
                            </div>

                            <div class="optpl-details-card__actions">
                                <a :href="'https://my.optimizepress.com/template-store/' + pack.id" class="opui-btn opui-btn-primary" v-if="!pack.was_purchased" target="_blank">Purchase this Template Pack - ${{ pack.amount / 100 }} (one time)</a>
                                <a href="https://my.optimizepress.com" class="opui-btn opui-btn-success" v-else target="_blank">You already own this template pack.</a>
                            </div>
                        </div>

                        <div class="optpl-details-card__media" v-if="pack.preview">
                            <figure><img :src="pack.preview" alt="" /></figure>
                        </div>
                    </div>

                    <div class="optpl-details-related">
                        <div class="optpl-templates__container">
                            <div class="optpl-templates__group">
                                <RelatedTemplates :group="relatedTemplates" :showDetails="pack.was_purchased" :purchaseLink="'https://my.optimizepress.com/template-store/' + pack.id" :purchaseText="'Purchase Pack'" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <DetailsAreLoading v-if="!loaded" />
        </main>
    </Transition>
</template>

<script>
import { useFiltersStore } from '../store/filters'
import { useTemplatesStore } from '../store/templates'
import { mapStores } from 'pinia'
import Header from '../components/Global/Header.vue'
import Hero from '../components/Templates/Hero.vue'
import Filters from '../components/Templates/Filters.vue'
import RelatedTemplates from '../components/Templates/RelatedTemplates.vue'
import TemplateItem from '../components/Templates/TemplateItem.vue'
import Templates from '../components/Templates/Templates.vue'
import DetailsAreLoading from '../components/Loading/DetailsAreLoading.vue'

export default {
    components: { DetailsAreLoading, Header, Hero, Filters, RelatedTemplates, TemplateItem, Templates },
    computed: {
        ...mapStores(useFiltersStore, useTemplatesStore),
    },
    data() {
        return {
            filtersStore: useFiltersStore(),
            templatesStore: useTemplatesStore(),
            relatedTemplates: {},
            packUid: this.$route.params.uid,
            pack: null,
            loaded: false,
        }
    },
    created() {
        this.loadInitialData()
    },
    mounted() {
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'instant' })
        }, 10)
    },
    methods: {
        loadInitialData() {
            this.$http
                .get('/templates/packs/' + this.packUid)
                .then(async response => {
                    // console.log("PACK: ", response.data.data);
                    this.pack = response.data.data

                    if (this.pack.templates) {
                        this.relatedTemplates = {
                            title: 'Templates In This Pack',
                            items: this.pack.templates,
                        }
                    } else {
                        this.relatedTemplates = {}
                    }

                    this.loaded = true
                })
                .catch(error => {
                    this.$toast.error('Error when fetching template pack.')
                    console.error(error)
                    this.loaded = true
                })
        },
    },
}
</script>
